import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalInfo } from 'src/app/shared/models';

@Component({
  selector: 'app-delete-account-modal',
  templateUrl: './delete-account-modal.component.html',
  styleUrls: ['./delete-account-modal.component.scss'],
  standalone: false,
})
export class DeleteAccountModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public accountName: string | null,
    public dialogRef: MatDialogRef<DeleteAccountModalComponent>,
  ) {}

  info: ModalInfo = {
    type: 'alert-modal',
    closeModalBtnId: 'close-btn-m',
    header: {
      titleContent: true,
    },
    actions: {
      cancel: {
        id: 'm-cancel-action-btn',
      },
      submitWithClothing: {
        id: 'm-submit-action-btn',
        extraClass: 'alert',
        type: 'delete',
      },
    },
  };

  closeModal(event: Event): void {
    this.dialogRef.close(event);
  }
}
